import AddOnServiceTemplate from "../../../templates/admin/addOnService";

const AddOnServiceScreen = () => {
  return <AddOnServiceTemplate />;
};

export default AddOnServiceScreen;
